export default {
  login: {
    title: 'Sign in',
    subtitle: 'You can sign in using account data from the ',
    password: 'Password',
    login: 'Sign in',
    registerLink: 'Sign up',
    resetPasswordLink: 'Reset password',
    animalkiApp: 'Animalki app',
  },
  validates: {
    requiredField: 'Required field',
    emailNotValid: 'E-mail is not valid',
    phoneNumber: 'Enter a valid phone number',
    minLength: 'This value should be 15 characters long',
    passwordLength: 'The password must be between 3 and 16 characters long',
    repeatPassword: 'Your password and confirmation password do not match',
    chooseVisitTime: 'Choose the visit time',
  },
  alerts: {
    loginError: 'An error occured while logging in',
    getPetsError: 'An error occurred while fetching the list of pets',
    createPetSuccess: 'The pet has been created successfully',
    createPetError: 'An error occurred while creating new pet',
    updatePetSuccess: 'The pet has been updated successfully',
    updatePetError: 'An error occurred while updating pet',
    deletePetSuccess: 'The pet has been deleted successfully',
    deletePetError: 'An error occurred while deleting pet',
    saveProfileError: 'An error occured while saving the profile',
    saveProfileSuccess: 'The profile has been saved successfully',
    registerError: 'An error occurred while trying to register new user',
    registerSuccess: 'Your registration was successful. Please check your email.',
    resetPasswordSuccess: 'The password has been reset successfully. Please check your email',
    resetPasswordError: 'An error occured while trying to reset a password',
    getVisitTypesError: 'An error occurred while fetching the list of visit types',
    getVisitTimesError: 'An error occurred while fetching the list of visit times',
    bookAppointmentError: 'An error occured while trying to book an appointment',
  },
  messages: {
    noDataAvailable: 'No data available',
    addPet: 'Add a new pet by clicking the \'+\' button',
    choosePet: 'Choose a pet...',
    chooseOrAddPet: 'Choose a pet or add a new one by clicking the \'+\' button',
  },
  button: {
    cancel: 'Cancel',
    add: 'Add',
    save: 'Save',
    no: 'No',
    yes: 'Yes',
    clear: 'Clear',
    back: 'Back',
    next: 'Next',
    send: 'Send',
    return: 'Return',
  },
  header: {
    planVisit: 'Plan visit',
    profile: 'My profile',
    pets: 'My pets',
    logout: 'Logout',
  },
  profile: {
    form: {
      name: 'First name*',
      surname: 'Last name*',
      phone: 'Phone number*',
      street: 'Street*',
      city: 'City*',
      zipCode: 'Zip code*',
      country: 'Country*',
    },
  },
  pets: {
    form: {
      newPet: 'New pet',
      editPet: 'Edit pet',
      name: 'Name*',
      species: 'Animal species*',
      race: 'Animal breed*',
      sex: 'Sex*',
      birthDate: 'Date of birth*',
      weight: 'Weight*',
      weightSuffix: 'kg',
      microchip: 'Microchip',
      passport: 'Passport',
      sterilized: 'sterilized',
      castrated: 'Castrated',
    },
    delete: {
      title: 'Delete pet',
      description: 'Are you sure you want to delete selected pet?',
    },
  },
  register: {
    title: 'Register',
    register: 'Register',
    password: 'Password',
    repeatPassword: 'Repeat password',
    acceptRules: 'I have read and accept the Privacy Policy and the use of cookies contained in',
    termsOfUse: 'Terms of service',
  },
  resetPassword: {
    title: 'Reset password',
    subtitle: 'To continue resetting your password, enter your email address below',
  },
  visits: {
    stepper: {
      firstStep: 'Complete your profile data',
      secondStep: 'Choose a pet',
      thirdStep: 'Select date and type of visit',
    },
  },
  appointment: {
    visitType: 'Choose the type of visit...',
    date: 'Choose visit date...',
    description: 'Description of the visit',
    afterTwelve: 'From 12:00',
    beforeSixteenth: '12:00 - 16:00',
    afterSixteenth: 'From 16:00',
    noAppointments: 'No appointments',
    summary: 'Thank you for making a reservation. Information about the confirmation of the visit will be sent to your e-mail address.',
  },
}
